import React from 'react';
import PropTypes from 'prop-types';
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';
import {styled} from '@mui/material/styles';

/**
 * @param {IconWithTooltip.propTypes} props
 * @param {Object} props.priceData
 * @param {Object} props.parsedPR
 * @return {JSX.Element}
 * @constructor
 */
export function IconWithTooltip(props) {
    // Create a new Tooltip with a fixed width
    const CustomWidthTooltip = styled(({className, ...props}) => (
        <Tooltip {...props} classes={{popper: className}} />
    ))({
        [`& .${tooltipClasses.tooltip}`]: {
            maxWidth: props?.innerStyle?.maxWidth || 200,
        },
    });

    return (
        <CustomWidthTooltip title={props.text} placement={props.placement} style={props.style}>
            <i className="material-icons pr-editor-header-details-icon">{props.icon}</i>
        </CustomWidthTooltip>
    );
}

IconWithTooltip.propTypes = {
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]),
    placement: PropTypes.string,
    style: PropTypes.object,
    icon: PropTypes.string,
};
